import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  Labeled,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { DoctoralStudyTypeLabels } from "utils/choices";
import { instructionLanguageLabel } from "../seatLabel";
import { SectionTitle } from "features/SectionTitle";

const ShowDoctoralPrograms = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за докторантска програма"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid item xs={12} md={6}>
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
        </Grid>

        <SectionTitle
          title="Форми на обучение"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <ArrayField source="studyForms">
          <Datagrid bulkActionButtons={false} sx={settings.style.detailsDatagrid}>
            <FunctionField
              label="Форма на обучение"
              render={r => DoctoralStudyTypeLabels[r.studyTypeId] ?? r.studyTypeId}
            />
            <FunctionField
              label="Език на обучение"
              render={r => instructionLanguageLabel(r.instructionLanguageId) || "—"}
            />
            <FunctionField
              label="Годишна такса"
              render={r => (r.annualFee ?? "—")}
            />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowDoctoralPrograms;
